import { languages } from '@avanta/shared/constants/common';

export const ImageLanguage = ({ language }: { language: string }): React.ReactElement => (
  <img
    src={languages[language as keyof typeof languages].image}
    alt={language}
    className="size-4 ml-1"
  />
);
